import { put, select, take } from 'redux-saga/effects';
import { apiAction, mapStateToArgs } from 'ctm-util-functions';
import { addCompleteAction } from './utils';

/**
 * Run the API onMount actions for each previous page.
 * This is slow because each action makes an async API call and to make it even slower
 * they are called in sequence, waiting for each one to complete before running the next.
 *
 * @param {Object} journeyModel - Instance of the class "PageSchemaModel" initialized with "page_schema.json".
 * @param {Object} currentPageName - Current page name.
 * @param {Object} pageState - Tightly coupled to PageWrapper mapStateToProps(), it has all page settings.
 */
export const runApiOnMountForEachPreviousPage = function* (journeyModel, currentPageName, pageState) {
    const allPreviousPages = journeyModel.getAllPreviousStepPages(currentPageName);
    const sequencedApiSchema = journeyModel.sequenceApiOnMountSchemas(allPreviousPages);
    if (Object.keys(sequencedApiSchema).length) {
        const completeActionType = 'ALL_ON_MOUNT_ACTIONS_COMPLETE';
        const restArgs = yield select(mapStateToArgs, sequencedApiSchema.restArgs);
        const action = addCompleteAction(apiAction(sequencedApiSchema, pageState, restArgs), completeActionType);
        yield put(action);
        yield take(completeActionType);
    }
};
